import React from 'react';
import { Col, Card, Row, Image } from "react-bootstrap"; // Added Image import
import PauloPfp from '../../../assets/icons/PauloPfp.svg';

const Holidays = () => (
    <Col className='col-34'>
        <Card className='rounded-4 shadow' style={{ backgroundColor: "#17296B", height: "100%" }}>
            <div className='m-2' style={{ height: "100%" }}>
                <Row className='border-bottom' style={{width: '100%', margin: '0 auto'}}>
                    <Col className='d-flex justify-content-start align-items-center gap-1 pb-2 text-white'>
                        <b className='ms-3' style={{ fontSize: "2.5vmin" }}>Feriados</b>
                    </Col>
                </Row>
                <div style={{ overflowY: "auto", overflowX: "hidden", height: "calc(100% - 4rem)", marginTop: "10px" }}>
                    <Row className='d-flex justify-content-center flex-column mt-1 gap-1 text-white'>
                        {['Sexta-feira Santa', 'Páscoa', 'Dia da Liberdade', 'Dia do Trabalhador'].map((holiday, index) => (
                            <Col key={index} className='col-12 mx-2'>
                                <Image src={PauloPfp} roundedCircle style={{ width: '2vw', height: '2vw', minWidth: '20px', minHeight: '20px' }} />
                                <b className='ms-3 fw-medium' style={{ fontSize: "2vmin" }}>{holiday}</b>
                            </Col>
                        ))}
                    </Row>
                </div>
            </div>
        </Card>
    </Col>
);

export default Holidays;
